<div *ngIf="showBanner">
    <div class="global-consent-banner">
		<div class="global-consent-banner__container">
			<div class="global-consent-banner__text">
				<p>
					We use cookies to help our site function correctly and to understand how it is used. By
					clicking "I understand", you agree to us doing so. You can find out more about cookies
					and how to manage them in our
					<a [href]="getCookieUrl()" target="_blank">Cookie Policy</a>.
				</p>
			</div>
			<div class="global-consent-banner__buttons">
				<a (click)="acceptConsent()" class="global-consent-banner__btn">
					I understand
				</a>
			</div>
		</div>
    </div>
</div>
